import { FocusEvent } from 'react';
import {
  FieldValues,
  Path,
  UseFormSetError,
  UseFormTrigger,
} from 'react-hook-form';
import { isEmailAvailable } from 'utils/authApi';

export const DUPLICATE_EMAIL_MESSAGE_UK = 'That email already exists.';
export const DUPLICATE_EMAIL_MESSAGE_DE = 'Diese E-Mail existiert bereits.';

type TDuplicateEmailCheckParams<T extends FieldValues> = {
  trigger: UseFormTrigger<T>;
  setError: UseFormSetError<T>;
  message: string;
};

export const getDuplicateEmailHandlers = <T extends FieldValues>({
  trigger,
  setError,
  message,
}: TDuplicateEmailCheckParams<T>) => {
  const emailField = 'email' as Path<T>;

  const showDuplicateEmail = (shouldFocus = false) =>
    setError(emailField, { type: 'duplicate', message }, { shouldFocus });

  const onEmailBlur = async (event: FocusEvent<HTMLInputElement>) => {
    const email = event.target.value;
    if (!email || !(await trigger(emailField))) {
      return;
    }
    if (!(await isEmailAvailable(email))) {
      showDuplicateEmail();
    }
  };

  const onDuplicateEmail = () => showDuplicateEmail(true);

  return { onEmailBlur, onDuplicateEmail };
};
